import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Skeleton } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import { Lead } from 'src/components/Assignee/Lead';
import { ClientTableRowModal } from 'src/store/clients/types';
import { RootState } from 'src/store';

const leadCellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '4px',
};

interface LeadCellRendererProps extends ICellRendererParams {
  data: ClientTableRowModal;
}

export const LeadCellRenderer: React.FC<LeadCellRendererProps> = React.memo(
  ({ data }) => {
    // this is not immutable when updating client is done so no re-render
    const updatingClientsIds = useSelector(
      (state: RootState) => state.clients.updatingClientsIds,
    );

    if (updatingClientsIds[data.userId]) {
      return (
        <div style={leadCellStyle}>
          <Skeleton variant="rect" width={20} height={20} />
        </div>
      );
    }

    return data.leadUser ? (
      <Lead lead={data.leadUser} companyId={data.company.id} />
    ) : (
      <div />
    );
  },
);
